/**
 * V2 — thin auth-sync facade over {@link endCustomerSession}.
 */
import type { QueryClient } from '@tanstack/react-query';
import type { RuntimeConfig } from '../../config/runtimeConfig.js';
import {
  endCustomerSession,
  type EndCustomerSessionReason,
} from './endCustomerSession.js';

export type { EndCustomerSessionReason };

export {
  beginSessionEndingLatch,
  endSessionEndingLatch,
  isSessionEndingLatchActive,
  markCustomerSessionStarted,
} from './endCustomerSession.js';

export interface CustomerAuthSyncDeps {
  tenantCode: string;
  config: RuntimeConfig;
  queryClient: QueryClient;
  clearMemorySession: () => void;
  setSessionHydrated: (value: boolean) => void;
}

let authSyncDeps: CustomerAuthSyncDeps | null = null;

export function registerCustomerAuthSyncDeps(next: CustomerAuthSyncDeps): () => void {
  authSyncDeps = next;
  return () => {
    if (authSyncDeps === next) {
      authSyncDeps = null;
    }
  };
}

function requireAuthSyncDeps(): CustomerAuthSyncDeps {
  if (authSyncDeps === null) {
    throw new Error('CustomerAuthSync deps not registered');
  }
  return authSyncDeps;
}

export async function endCustomerSessionGlobal(opts: {
  broadcast: boolean;
  callApi: boolean;
  api?: 'logout' | 'logout-all';
  reason?: EndCustomerSessionReason;
}): Promise<void> {
  const d = requireAuthSyncDeps();
  await endCustomerSession({
    tenantCode: d.tenantCode,
    config: d.config,
    queryClient: d.queryClient,
    clearMemorySession: d.clearMemorySession,
    setSessionHydrated: d.setSessionHydrated,
    ...opts,
  });
}

export { endCustomerSession };

